import * as api from "@/service/user";
import * as icons from "@element-plus/icons-vue";
import ElementPlus from "element-plus";
import "./assets/tailwind.css";

import "element-plus/dist/index.css";
import zhTw from "element-plus/es/locale/lang/zh-tw";
import { createApp } from "vue";
import VXETable from "vxe-table";
import VXETablePluginExportXLSX from "vxe-table-plugin-export-xlsx";
import "vxe-table/lib/style.css";
import "xe-utils";
import App from "./App.vue";
import router from "./router";
import { getLineClientId } from "./service/line";
import { getSystemConfig } from "./service/system-config";
import store from "./store";
import * as glebleMethod from "./util/globle-method";
import i18n from "./util/i18n";
import { LineLogin } from "./util/line-login";
const app = createApp(App);
VXETable.use(VXETablePluginExportXLSX);
VXETable.setup({
  // 对组件内置的提示语进行国际化翻译
  i18n: (key, args) => i18n.global.t(key, args),
});

// ...
app
  .use(ElementPlus, {
    locale: zhTw,
  })
  .use(VXETable);

for (const [key, value] of Object.entries(icons)) {
  app.component(key, value);
}

declare module "@vue/runtime-core" {
  interface ComponentCustomProperties {
    elMessageBoxConfirm: (
      message: glebleMethod.ElMessage,
      ConfirmFunction: () => void,
      CancelFunction?: () => void,
    ) => void;
    uploadImage: (File: File) => Promise<string>;
  }
}
Object.assign(app.config.globalProperties, glebleMethod);

async function init() {
  const { data } = await getLineClientId();
  const lineLogin = new LineLogin(data);
  const lineData = await lineLogin.getProfile();
  await api
    .login({
      identityType: 0,
      identifier: lineData.userId,
      credential: window.localStorage.getItem("lineAccessToken"),
      userName: lineData.displayName,
      userAvatar: lineData.pictureUrl,
    })
    .then(() => {
      store.state.userData = {
        userName: lineData.displayName,
        userAvatar: lineData.pictureUrl,
      };
      getSystemConfig().then((res) => {
        if (!res.data) {
          throw new Error("系統設定資料不存在，請聯絡管理員");
        }

        const { id, connectionName, ...info } = res.data;

        console.log(info);

        store.state.clientName = res.data.clientName;
        document.title = res.data.clientName;
        app.use(store).use(router).use(ElementPlus).mount("#app");
      });
      // app.use(store).use(router).use(ElementPlus).mount("#app");
    });
}
init();
